import { render, staticRenderFns } from "./TheGreetingMessage.vue?vue&type=template&id=5bfa3560"
import script from "./TheGreetingMessage.vue?vue&type=script&lang=js"
export * from "./TheGreetingMessage.vue?vue&type=script&lang=js"
import style0 from "./TheGreetingMessage.vue?vue&type=style&index=0&id=5bfa3560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports